import sanityClient from "../client";
import imageUrlBuilder from "@sanity/image-url";
import { useState, useEffect } from "react";
import PortableText from "react-portable-text";

export default function Campaign(props) {
  const builder = imageUrlBuilder(sanityClient);
  function urlFor(source) {
    return builder.image(source);
  }
  const [campaigns, setCampaigns] = useState(null);
  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "campaign"]  | order(_updatedAt desc) {
      image{
      asset->{
        _id,
        url
      },
    },
    body
    }`
      )
      .then((data) => {
        setCampaigns(data);
      })
      .catch(console.error);
  }, []);

  return (
    <section className="my-20">
      <header>
        <h1 className="text-2xl font-bold text-center mb-20">
          Our Shared Work
        </h1>
      </header>
      <main className="affliationWideCampaigns flex flex-col sm:flex-row flex-wrap gap-12 justify-evenly">
        {campaigns !== null && (
          <>
            <section className="item sm:w-5/12 flex flex-col gap-3">
              <img src="/KYR_Affiliation_Graphic.jpg" alt="" style={{borderRadius: "4px"}} />
              <div className="text-sm text-center">
                <p>We want to ensure you’re informed and prepared. Many of you may be feeling uncertain about the changes the new administration is bringing. Now is the time to get prepared, stay vigilant and fight for your rights. Find more resources for safety planning in English and multiple Asian languages on AJSOCAL's website.</p>
                <p><strong><a href="https://ajsocal.org/immigration/" className="underline text-sm"><span>Immigration Services and Resources</span></a></strong></p>
              </div>
            </section>
            <section className="item sm:w-5/12 flex flex-col gap-3">
              <img src="/ARH.png" alt="" style={{borderRadius: "4px"}} />
              <div className="text-sm text-center">
                <p>Browse our National Asian American and Native Hawaiian & Pacific Islander Resource Directory to find service providers and community organizations across the country who serve the Asian American community.</p>
                <p><strong><a href="https://asianresourcehub.org/" className="underline text-sm"><span>ASIAN RESOURCE HUB</span></a></strong></p>
              </div>
            </section>
            {campaigns.map((campaign, key) => (
              <section key={key} className="item sm:w-5/12 flex flex-col gap-3">
                <img src={urlFor(campaign.image.asset.url).url()} alt="" />
                <PortableText
                  content={campaign.body}
                  className="text-sm text-center"
                />
              </section>
            ))}
            
          </>
        )}
      </main>
    </section>
  );
}
